import React, { useState, useEffect, Fragment, useMemo } from "react";
import styled from "styled-components";
import Ranus from "./assets/Ranus.svg";
import PickProductModal from "./PickProductModal";
import OrderServices from "../based/services/OrderServices";
import Common from "../based/Common";
import { useHistory } from "react-router-dom";
import EditBankAccountModal from "./EditBankAccountModal";
import { Notify } from "../based/Notify";
import { NOTIFY, PLATFORM } from "../based/Constants";
import Loading from "../based/Loading";

function ReturnOrderEdit(props) {
    const [showModal, setShowModal] = useState(false);
    const { orderId } = props.match.params;
    const [orderDetail, setOrderDetail] = useState({});
    const [listProduct, setListProduct] = useState([]);
    const history = useHistory();
    const [showEditBankAccountModal, setShowEditBankAccountModal] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (orderId) {
            getOrderDetail(+orderId);
        }
    }, [orderId]);

    const getOrderDetail = async (orderId) => {
        const [err, data] = await OrderServices.GetOrderDetailReturnModel(orderId);
        if (!err && data) {
            //config thông tin đơn hàng
            let dt = { ...data };
            if (!dt.orderReturnPickup) dt.orderReturnPickup = JSON.parse(JSON.stringify(dt.orderShipping));
            if (!dt.orderReturnShipping) dt.orderReturnShipping = JSON.parse(JSON.stringify(dt.orderShipping));
            if (!dt.orderReturnBank) dt.orderReturnBank = {};
            setOrderDetail(dt);

            //config thông tin sản phẩm
            setListProduct(dt.pickProductModels);
        } else {
            setOrderDetail({});
        }
    };

    const handleSave = async () => {
        if (isReadOnly) return;
        let od = { ...orderDetail };

        //nếu không có hoàn tiền thì không cần thông tin ngân hàng
        if (!anyReFund) {
            od.orderReturnBank = null;
        }

        //nếu không có hoàn hàng thì không cần thông tin pickup
        if (!anyReturnDefective) {
            od.orderReturnPickup = null;
        }

        //nếu không có sản xuất lại thì không cần thông tin sản phẩm
        if (!anyReProduce) {
            od.orderReturnShipping = null;
        }

        setLoading(true);
        const [err, data] = await OrderServices.UpdateOrderDetailRefund({ ...od, pickProductModels: listProduct });
        setLoading(false);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Cập nhật thành công");
            history.push("/return-order-overview");
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Cập nhật thất bại");
        }
    };

    const totalRefundAmount = useMemo(() => {
        return listProduct.reduce((total, item) => {
            return total + (item.isReFund ? item.refundAmount : 0);
        }, 0);
    }, [listProduct]);

    const totalRefundProducts = useMemo(() => {
        return listProduct.reduce((total, item) => {
            return total + (item.isReFund ? 1 : 0);
        }, 0);
    }, [listProduct]);

    const anyReturnDefective = useMemo(() => {
        return listProduct.some((item) => item.isReturnDefective);
    }, [listProduct]);

    const anyReProduce = useMemo(() => {
        return listProduct.some((item) => item.isReProduce);
    }, [listProduct]);

    const anyReFund = useMemo(() => {
        return listProduct.some((item) => item.isReFund);
    }, [listProduct]);

    const isReadOnly = useMemo(() => {
        return (orderDetail?.id || 0) > 0;
    }, [orderDetail?.id]);

    //gom sản phẩm sản xuất lại theo sản phẩm gốc để hiển thị số lượng
    const reProduceProducts = useMemo(() => {
        let grouped = [];
        listProduct
            .filter((item) => item.isReProduce)
            .forEach((item) => {
                let exist = grouped.find((x) => x.orderProductId === item.orderProductId);
                if (exist) exist.quantity += 1;
                else grouped.push({ ...item, quantity: 1 });
            });
        return grouped;
    }, [listProduct]);

    return (
        <Fragment>
            <Loading show={loading} fullScreen={true} />

            <Wrapper>
                {orderDetail && orderDetail.orderId > 0 ? (
                    <div class="container return-request-details">
                        <div class="header">
                            <div class="logo-title">{orderDetail.platform == PLATFORM.Internal && <img src={Ranus} alt="RANUS" class="logo" />}</div>
                            <div class="order-info">
                                <div>
                                    <strong>Mã hệ thống:</strong> <span>{orderDetail.orderId}</span>
                                </div>
                                <div>
                                    <strong>Mã đơn hàng:</strong> <span>{orderDetail.orderNumber}</span>
                                </div>
                                {orderDetail.orderShipping && (
                                    <>
                                        <div>
                                            <strong>Tên:</strong> <span>{orderDetail.orderShipping.userName}</span>
                                        </div>
                                        <div>
                                            <strong>SĐT:</strong> <span>{orderDetail.orderShipping.phoneNumber}</span>
                                        </div>
                                        <div>
                                            <strong>Địa chỉ:</strong> <span>{orderDetail.orderShipping.fullAddress}</span>
                                        </div>
                                    </>
                                )}

                                <div>
                                    <strong>PTTT:</strong> <span>{orderDetail.paymentMethodName}</span>
                                </div>
                                <div>
                                    <strong>Tổng thanh toán:</strong> <span>{Common.formatCurrency(orderDetail.finallyPrice)}</span>
                                </div>
                            </div>
                            <div class="shipping-info">
                                {orderDetail.shippingCompanyId > 0 && (
                                    <>
                                        <div>
                                            <strong>Đơn vị VC:</strong> <span>{orderDetail.shippingCompanyName}</span>
                                        </div>
                                        {orderDetail.shippingTrackingNumber && (
                                            <>
                                                <div>
                                                    <strong>Mã vận chuyển:</strong> <span>{orderDetail.shippingTrackingNumber}</span>
                                                </div>
                                                <div>
                                                    <strong>Link vận chuyển:</strong>
                                                    <a href={`https://spx.vn/track?${orderDetail.shippingTrackingNumber}`} target="_blank">
                                                        {`https://spx.vn/track?${orderDetail.shippingTrackingNumber}`}
                                                    </a>
                                                </div>
                                            </>
                                        )}
                                    </>
                                )}
                                {/*     
                                <div>
                                    <strong>Hình ảnh/video đóng gói:</strong>
                                    <div class="package-media">
                                        <a href="https://media.Url" target="_blank">
                                            <img src="https://media.ThumbnailUrl" alt="Package Media" />
                                        </a>
                                    </div>
                                </div> */}
                            </div>
                        </div>

                        <div class="actions-bar">
                            <button
                                class="btn btn-success"
                                disabled={isReadOnly}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (isReadOnly) return;
                                    setShowModal(true);
                                }}
                            >
                                Thêm sản phẩm khiếu nại +
                            </button>
                            {/* <label>
                                <input type="radio" name="filter" checked /> Sản xuất lại tất cả
                            </label>
                            <label>
                                <input type="radio" name="filter" /> Hoàn tiền tất cả
                            </label>
                            <label>
                                <input type="radio" name="filter" /> Hoàn lại tất cả hàng lỗi
                            </label> */}
                        </div>

                        <div class="product-table-section">
                            <table class="table table-bordered product-table">
                                <thead>
                                    <tr>
                                        <th>STT</th>
                                        <th>Hình ảnh</th>
                                        <th>Sản phẩm</th>
                                        <th>Giá sau giảm</th>
                                        <th>Phương án</th>
                                        <th>Hoàn lại hàng lỗi</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listProduct && listProduct.length > 0 ? (
                                        listProduct.map((item, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>
                                                    {item.frontImage && <img src={item.frontImage} alt="Product" class="product-img" />}
                                                    {item.backImage && <img src={item.backImage} alt="Product" class="product-img" />}
                                                </td>
                                                <td>{item.name}</td>
                                                <td>
                                                    <span className="sale-price">{Common.formatCurrency(item.price)}</span>
                                                    <br />
                                                    {item.originalPrice > 0 && <span class="old-price">{Common.formatCurrency(item.originalPrice)}</span>}
                                                </td>
                                                <td className={`restatus ${item.isReFund ? "active" : ""}`}>
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name={`option-${i}`}
                                                            checked={item.isReProduce}
                                                            disabled={isReadOnly}
                                                            onChange={(e) => {
                                                                if (isReadOnly) return;
                                                                let value = e.target.checked;
                                                                let lstProduct = [...listProduct];
                                                                lstProduct[i].isReProduce = value;
                                                                lstProduct[i].isReFund = !value;
                                                                setListProduct(lstProduct);
                                                            }}
                                                        />
                                                        Sản xuất lại
                                                    </label>
                                                    <br />
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name={`option-${i}`}
                                                            checked={item.isReFund}
                                                            disabled={isReadOnly}
                                                            onChange={(e) => {
                                                                if (isReadOnly) return;
                                                                let value = e.target.checked;
                                                                let lstProduct = [...listProduct];
                                                                lstProduct[i].isReFund = value;
                                                                lstProduct[i].isReProduce = !value;
                                                                setListProduct(lstProduct);
                                                            }}
                                                        />
                                                        Hoàn tiền ({Common.formatCurrency(item.refundAmount)})
                                                    </label>
                                                </td>
                                                <td>
                                                    {/* <span class={`status ${item.isReturnDefective ? "success" : "error"}`}>{item.isReturnDefective ? "Có" : "Không"}</span> */}
                                                    <label htmlFor={`defective-${i}`}>
                                                        <input
                                                            type="checkbox"
                                                            id={`defective-${i}`}
                                                            checked={item.isReturnDefective}
                                                            disabled={isReadOnly}
                                                            onChange={(e) => {
                                                                if (isReadOnly) return;
                                                                let value = e.target.checked;
                                                                let lstProduct = [...listProduct];
                                                                lstProduct[i].isReturnDefective = value;
                                                                setListProduct(lstProduct);
                                                            }}
                                                        />
                                                        {item.isReturnDefective ? "Có" : "Không"}
                                                    </label>
                                                </td>
                                                <td>
                                                    <a
                                                        className={`text text-danger ${isReadOnly ? "disabled-link" : ""}`}
                                                        title="Xóa"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            if (isReadOnly) return;
                                                            let lstProduct = [...listProduct];
                                                            lstProduct.splice(i, 1);
                                                            setListProduct(lstProduct);
                                                        }}
                                                    >
                                                        <span>
                                                            <i className="fa fa-trash" aria-hidden="true"></i>
                                                        </span>
                                                    </a>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7">Không có sản phẩm nào được thêm.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {orderDetail.reProduceOrderId > 0 && (
                            <div className="reproduce-section">
                                <h4>
                                    Đơn sản xuất lại
                                    <a className="text text-custom reproduce-order-link" href={`/order-detail/${orderDetail.reProduceOrderId}`} target="_blank" rel="noreferrer">
                                        {orderDetail.reProduceOrderNumber || orderDetail.reProduceOrderId}
                                    </a>
                                </h4>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Hình ảnh</th>
                                            <th>Sản phẩm</th>
                                            <th>Size/Màu</th>
                                            <th>Số lượng</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reProduceProducts.length > 0 ? (
                                            reProduceProducts.map((item, i) => (
                                                <tr key={i}>
                                                    <td>
                                                        {item.frontImage && <img src={item.frontImage} alt="Product" class="product-img" />}
                                                        {item.backImage && <img src={item.backImage} alt="Product" class="product-img" />}
                                                    </td>
                                                    <td>{item.name}</td>
                                                    <td>{`${item.size || ""} ${item.color || ""}`}</td>
                                                    <td>{item.quantity}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4">Không có sản phẩm sản xuất lại.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <div className="reproduce-note">Đơn sản xuất lại đã được tạo, các thay đổi sau đó sẽ không tạo thêm đơn mới.</div>
                            </div>
                        )}

                        <div class="address-section">
                            {orderDetail.orderReturnPickup && anyReturnDefective && (
                                <div class="address-block">
                                    <h4>Địa chỉ lấy hàng hoàn</h4>
                                    <div>
                                        <strong>Tên người nhận:</strong> {orderDetail.orderReturnPickup.userName}
                                    </div>
                                    <div>
                                        <strong>Số điện thoại:</strong> {orderDetail.orderReturnPickup.phoneNumber}
                                    </div>
                                    <div>
                                        <strong>Địa chỉ:</strong> {orderDetail.orderReturnPickup.fullAddress}
                                    </div>
                                    <div>
                                        <strong>Phường/Xã:</strong> {orderDetail.orderReturnPickup.wardName}
                                    </div>
                                    <div>
                                        <strong>Quận/Huyện:</strong> {orderDetail.orderReturnPickup.districtName}
                                    </div>
                                    <div>
                                        <strong>Tỉnh/Thành phố:</strong> {orderDetail.orderReturnPickup.provinceName}
                                    </div>
                                </div>
                            )}
                            {orderDetail.orderReturnShipping && anyReProduce && (
                                <div class="address-block">
                                    <h4>Địa chỉ giao lại/giao thêm</h4>
                                    <div>
                                        <strong>Tên người nhận:</strong> {orderDetail.orderReturnShipping.userName}
                                    </div>
                                    <div>
                                        <strong>Số điện thoại:</strong> {orderDetail.orderReturnShipping.phoneNumber}
                                    </div>
                                    <div>
                                        <strong>Địa chỉ:</strong> {orderDetail.orderReturnShipping.fullAddress}
                                    </div>
                                    <div>
                                        <strong>Phường/Xã:</strong> {orderDetail.orderReturnShipping.wardName}
                                    </div>
                                    <div>
                                        <strong>Quận/Huyện:</strong> {orderDetail.orderReturnShipping.districtName}
                                    </div>
                                    <div>
                                        <strong>Tỉnh/Thành phố:</strong> {orderDetail.orderReturnShipping.provinceName}
                                    </div>
                                </div>
                            )}
                        </div>
                        {anyReFund && (
                            <div class="payment-section">
                                <div class="payment-info">
                                    <label className="required">Thông tin hoàn tiền</label>
                                    <a
                                        href=""
                                        className={`text text-custom edit-bank-account ${isReadOnly ? "disabled-link" : ""}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            if (isReadOnly) return;
                                            setShowEditBankAccountModal(true);
                                        }}
                                    >
                                        Chỉnh sửa
                                    </a>
                                    {orderDetail.orderReturnBank && (
                                        <>
                                            <div>
                                                <strong>Ngân hàng:</strong> {orderDetail.orderReturnBank.bankName}
                                            </div>
                                            <div>
                                                <strong>Số tài khoản:</strong> {orderDetail.orderReturnBank.bankAccountNumber}
                                            </div>
                                            <div>
                                                <strong>Tên tài khoản:</strong> {orderDetail.orderReturnBank.bankAccountName}
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div class="refund-amount">
                                    <div>
                                        <strong>Số tiền cần hoàn ({totalRefundProducts} sp):</strong>
                                    </div>
                                    <div class="amount">{Common.formatCurrency(totalRefundAmount)}</div>
                                </div>
                            </div>
                        )}

                        {/* <div class="note-section">
                            <div class="form-group">
                                <label for="note">Ghi chú</label>
                                <input type="text" id="note" class="form-control" placeholder="Thêm ghi chú" />
                            </div>
                            <div class="form-group">
                                <label>Hình ảnh</label>
                                <div class="upload-box">
                                    <button class="btn btn-upload">Thêm +</button>
                                </div>
                            </div>
                        </div> */}

                        <div class="footer-actions">
                            <button
                                class="btn btn-danger"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    history.push("/return-order-overview");
                                }}
                            >
                                Hủy
                            </button>
                            {/* <button class="btn btn-secondary">Tạo link yêu cầu</button> */}
                            <button
                                class="btn btn-primary"
                                disabled={isReadOnly}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (isReadOnly) return;

                                    //nếu có hoàn tiền thì bắt buộc phải có thông tin ngân hàng
                                    if (anyReFund && (!orderDetail.orderReturnBank || !orderDetail.orderReturnBank.bankCode)) {
                                        Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Vui lòng cung cấp thông tin ngân hàng để hoàn tiền");
                                        return;
                                    }
                                    handleSave();
                                }}
                            >
                                Tạo yêu cầu
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="container">
                        <h3>Không tìm thấy đơn hàng</h3>
                        <p>Vui lòng kiểm tra lại mã đơn hàng hoặc liên hệ với bộ phận hỗ trợ.</p>
                    </div>
                )}
            </Wrapper>
            <PickProductModal
                orderId={+orderId}
                show={!isReadOnly && showModal}
                onClose={() => setShowModal(false)}
                onConfirm={(lst) => {
                    if (isReadOnly) return;
                    let lstProduct = [...listProduct];

                    //dựa trên selected quantity, tách lst ra theo từng dòng và add vào ds
                    lst.forEach((item) => {
                        for (let i = 0; i < item.selectedQuantity; i++) {
                            lstProduct.push({
                                ...item,
                                isReProduce: true, // mặc định là sản xuất lại
                                isReturnDefective: false, // mặc định là không lỗi
                                isReFund: false, // mặc định là không hoàn tiền
                                refundAmount: item.price, // mặc định là hoàn tiền theo giá sản phẩm
                            });
                        }
                    });
                    setListProduct(lstProduct);
                    setShowModal(false);
                }}
            />
            <EditBankAccountModal
                show={!isReadOnly && showEditBankAccountModal}
                onClose={() => setShowEditBankAccountModal(false)}
                onConfirm={(data) => {
                    if (isReadOnly) return;
                    let updatedOrderDetail = { ...orderDetail };
                    updatedOrderDetail.orderReturnBank = {
                        bankCode: data.bankCode,
                        bankName: data.bankName,
                        bankAccountNumber: data.bankAccountNumber,
                        bankAccountName: data.bankAccountName,
                    };
                    setOrderDetail(updatedOrderDetail);
                    setShowEditBankAccountModal(false);
                }}
            />
        </Fragment>
    );
}

export default ReturnOrderEdit;

const Wrapper = styled.div`
    .payment-info label {
        color: rgb(68, 68, 68);
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    button.btn.btn-primary {
        margin-left: auto;
    }

    .edit-bank-account {
        margin: 0 24px 0 auto;
    }

    .payment-info {
        display: flex;
        flex-wrap: wrap;
    }

    .payment-info h4 {
        display: inline-block;
        width: fit-content;
    }

    .payment-info div {
        width: 100%;
    }

    tbody label {
        margin: 0;
        align-items: center;
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        display: flex;
    }

    tbody label input {
        margin-right: 6px;
    }

    td.restatus.active {
        border: 1px solid #d9d9d9;
        background: #fffac9;
    }

    td.restatus {
        vertical-align: middle;
    }

    .header {
        border: 1px solid #f1f1f1;
        background: #fff;
        padding: 26px 20px;
        margin: 24px 0;
        display: flex;
        flex-wrap: wrap;
    }

    .return-request-details {
    }

    .logo-title {
        width: 100%;
        margin: 0 0 12px 0;
    }

    .order-info {
        width: 50%;
    }

    .shipping-info {
        flex: 1;
        border: 1px solid #f1f1f1;
        background: #f1f1f1;
        padding: 10px 16px;
    }

    .order-info > div {
        margin: 5px 0;
        display: flex;
    }

    .order-info > div strong {
        font-size: 14px;
        font-weight: 700;
        width: 30%;
    }

    .order-info > div span {
        margin-left: 12px;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        flex: 1;
    }

    .shipping-info > div {
        margin: 5px 0;
        display: flex;
    }

    .shipping-info > div strong {
        width: 30%;
        color: #a4a4a4;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
    }

    span {
    }

    .shipping-info > div span,
    .shipping-info > div a {
        margin-left: 12px;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
    }

    .actions-bar {
        margin: 24px 0;
        display: flex;
        align-items: center;
    }

    .actions-bar .btn {
        background: #64c5b1 !important;
    }

    .actions-bar .btn:disabled,
    button.btn.btn-primary:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }

    .disabled-link {
        opacity: 0.45;
        cursor: not-allowed;
        pointer-events: auto;
    }

    .actions-bar label {
        margin: 0 12px;
        display: flex;
        font-size: 14px;
    }

    .actions-bar label input {
        margin-right: 10px;
    }

    table thead {
        border: 1px solid #d9d9d9;
        background: #d9d9d9;
    }

    thead tr th {
        vertical-align: middle;
    }

    table thead tr th {
        vertical-align: middle;
        align-items: center;
    }

    img.product-img {
        width: 70px;
        height: 70px;
        margin: 6px;
    }

    span.sale-price {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 142.857% */
    }

    span.old-price {
        color: #a4a4a4;
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 166.667% */
        text-decoration-line: line-through;
    }

    tbody tr {
        background: white;
    }

    .reproduce-section {
        margin: 16px 0;
    }

    .reproduce-section h4 {
        display: flex;
        align-items: center;
    }

    .reproduce-section .reproduce-order-link {
        margin-left: 12px;
        font-size: 16px;
        font-weight: 700;
    }

    .reproduce-section .reproduce-note {
        color: #a0a0a0;
        font-family: Roboto;
        font-size: 13px;
        font-style: italic;
    }

    .address-section {
        display: flex;
        justify-content: space-between;
    }

    .address-block {
        width: calc(50% - 10px);
        padding: 16px;
        border: 1px solid #f1f1f1;
        background: #fff;
    }

    .address-block h4 {
        color: #444;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .address-block div {
        display: flex;
        margin: 5px 0;
    }

    .address-block div strong {
        width: 30%;
        flex-shrink: 0;
    }

    .payment-section {
        border: 1px solid #f1f1f1;
        background: #fff;
        margin: 12px 0;
        padding: 16px;
        display: flex;
    }

    .payment-info h4 {
        color: #444;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .refund-amount {
        border: 1px solid #f1f1f1;
        background: #f1f1f1;
        margin-left: auto;
        padding: 20px 16px;
        width: calc(50% - 20px);
    }

    .refund-amount div {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .amount {
        color: #444;
        font-family: Roboto;
        font-size: 24px !important;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin: 10px 0;
    }

    .payment-info div {
        display: flex;
        margin: 6px 0;
    }

    .payment-info div strong {
        width: 100px;
    }

    .payment-info {
        flex: 1;
    }

    .note-section {
        border: 1px solid #f1f1f1;
        background: #fff;
        padding: 20px 16px;
        display: flex;
        justify-content: space-between;
    }

    .note-section .form-control {
        border: 1px solid #ededed;
        background: #fff;
    }

    .note-section .form-group {
        width: 45%;
    }

    .footer-actions {
        margin: 10px 0;
        display: flex;
    }

    button.btn.btn-secondary {
        margin: 0 10px 0 auto;
    }

    button.btn.btn-primary {
        background: #64c5b1 !important;
    }
`;
